import React from "react";
import { Box } from "@mantine/core";
import { PlayerType, ThemeType } from "../util/types";
import DynamicText from "./DynamicText";
import PlayerBadges from "./PlayerBadges";
import PlayerReminder from "./PlayerReminder";
import DynamicImage from "./DynamicImage";
import { motion, AnimatePresence } from "framer-motion";

type InstructionsProps = {
  theme: ThemeType;
  round: string;
  instructions: string;
  imageSrc?: string;
  reminder: string;
  players?: PlayerType[];
  judge?: string;
  onRenderComplete?: () => void;
};

const Instructions = ({
  theme,
  round,
  instructions,
  imageSrc,
  reminder,
  players,
  judge,
  onRenderComplete = () => {},
}: InstructionsProps) => {
  const instructionsNewLines = instructions.split("\n");
  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        textAlign: "center",
        height: "calc(100vh - 40px)",
        justifyContent: "space-between",
        marginBottom: 20,
        marginTop: 20,
      }}
    >
      <DynamicText
        style={{ color: theme.ButtonColor, fontSize: 15, margin: 10 }}
      >
        {round}
      </DynamicText>
      <AnimatePresence>
        {instructionsNewLines.map((line, index) => (
          <motion.div
            key={index + instructions}
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 1, delay: index * 0.5 }}
            onAnimationComplete={() => {
              console.log("Animation complete for line:", line);
              if (index === instructionsNewLines.length - 1) {
                onRenderComplete();
              }
            }}
            exit={{
              scale: 0,
              opacity: 0,
              transition: {
                duration: 0.5,
                delay: index * 0.5,
              },
            }}
          >
            <DynamicText
              style={{
                fontSize: 50,
              }}
            >
              {line.trim()}
            </DynamicText>
          </motion.div>
        ))}
      </AnimatePresence>
      {imageSrc && (
        <Box
          id={"ImageContainer"}
          style={{
            display: "flex",
            height: "70%",
            justifyContent: "center",
            alignContent: "center",
          }}
        >
          <DynamicImage src={imageSrc} parentId={"ImageContainer"} />
        </Box>
      )}
      <Box style={{ display: "flex", flexDirection: "column" }}>
        <PlayerReminder reminder={reminder} theme={theme} />
        {players && (
          <PlayerBadges
            players={players}
            judge={judge}
            theme={theme}
            allowTwoRows={false}
            showScores
          />
        )}
      </Box>
    </Box>
  );
};

export default Instructions;
